import { Box, CircularProgress, Modal, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPostsAction } from "../../../store/actions/poll";
import PostItem from "../Poll";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xl: "40%", lg: "40%", md: "40%", sm: "40%", xs: "40%" },

  bgcolor: "#ffffffaa",
  // p: 5,
  maxHeight: {
    lg: "72vh",
    md: "80vh",
    sm: "90vh",
  },
  overflow: "auto",
  borderRadius: "1em",
  border: 0,
};

const PollsComponent = ({ currentTime, data, play, pause }) => {
  const posts = useSelector((s) => s.posts.data.byId);
  const allIds = useSelector((s) => s.posts.data.allIds);
  const loading = useSelector((s) => s.posts.loading);
  const user = useSelector((s) => s.auth.user);
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
    if (!currentTime && data?.videoPause) {
      play();
    }
  };
  const dispatch = useDispatch();

  const fetchPosts = useCallback(
    ({ page, id, next }) => {
      getPostsAction({
        page,
        limit: 6,
        pageId: 183,
        next,
        type: "polls",
        id,
      })(dispatch);
    },
    [dispatch]
  );

  useEffect(() => {
    fetchPosts({ page: 1, id: data?.entityId });
  }, []);

  useEffect(() => {
    if (currentTime && data?.videoPause) {
      pause();
    }
  }, [currentTime, data]);
  return (
    <>
      <Modal
        open={open && currentTime ? true : false}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
      >
        <Box>
          {allIds?.length > 0 ? (
            allIds?.map((postId) => {
              let post = posts[postId];
              return (
                <Box key={postId} width={1}>
                  <PostItem post={post} pageId={141} user={user} />
                </Box>
              );
            })
          ) : (
            <>
              {!loading && (
                <Box
                  sx={{
                    width: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    pt: 1,
                    ...style,
                  }}
                >
                  {/* <img src={emptyPolls} alt="" /> */}
                  <Typography sx={{ my: 3 }} variant="h6">
                    there no
                  </Typography>
                </Box>
              )}
            </>
          )}
          {loading && (
            <Box
              sx={{
                width: 1,
                height: 0.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 2,
                ...style,
              }}
            >
              <CircularProgress height={50} />
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default PollsComponent;
